// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import QuestionablePartButtonGroup from './questionable-part-button-group';

const QuestionablePartSearchCriteria = props =>
    <div className='questionable-part-search-criteria'>
        <div className='part-number-criteria'>
            <LabeledCriteria
                className='part-number-criteria'
                isRequired={true}
                label='ENTER_A_PART_NUMBER'
                onInputChange={props.onPartNumberSearch}
                placeholder='PART_NUMBER'
                type='text'
                value={props.partNumber}
            />
        </div>
        <QuestionablePartButtonGroup
            canExport={props.canExport}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onDownloadToExcel}
            onPartSearchExecute={props.onPartSearchExecute}
            partNumber={props.partNumber}
        />
    </div>;

QuestionablePartSearchCriteria.displayName = 'QuestionablePartSearchCriteria';
QuestionablePartSearchCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDownloadToExcel: PropTypes.func.isRequired,
    onPartNumberSearch: PropTypes.func.isRequired,
    onPartSearchExecute: PropTypes.func.isRequired,
    partNumber: PropTypes.string.isRequired
};

export default QuestionablePartSearchCriteria;



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/components/questionable-part-search-criteria.js